export default "__VITE_ASSET__GPlCemCC__"